export const defaultFHLogo = require('./defaultFHLogo.png').default
export const dpsLogo = require('./dpsLogo.png').default
export const defaultPlaceholder = require('./defaultPlaceholder.jpg').default
export const avatarPlaceholder = require('./avatarPlaceholder.jpg').default
export const signUpGraphic = require('./signUpGraphic.png').default
export const underConstructionImage = require('./underConstruction.png').default
